import React, { useEffect, useState } from 'react';
import i18n from 'i18next'; // Import i18n to change the language

const Languageoption = ({ onChange }) => {
  const languages = [
    { code: 'en', name: 'English', image: '/images/united-kingdom.png' },
    { code: 'es', name: 'Spanish', image: '/images/spain.png' },
    { code: 'it', name: 'Italian', image: '/images/italy.png' },
    { code: 'fr', name: 'French', image: '/images/france.png' },
  ];

  const [isOpen, setIsOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(languages[0]);

  useEffect(() => {
    const lan = localStorage.getItem("selectedLanguage");
    if (lan) {
      setSelectedLanguage(JSON.parse(lan));
    }
  }, []);

  // Handle language selection and update the language using i18next
  const handleLanguageSelect = (language) => {
    if (!language) return; // If language is undefined or null, return early

    localStorage.setItem("selectedLanguage", JSON.stringify(language));
    setSelectedLanguage(language); // Update the selected language
    setIsOpen(false); // Close the dropdown

    // Change language using i18next
    i18n.changeLanguage(language.code, () => {
      if (onChange && typeof onChange === 'function') {
        onChange(language.code); // Ensure `onChange` is called with the correct value
      }
    });
  };

  return (
    <div
      style={{
        position: 'relative',
        width: '120px',
        display: 'flex',
        height: "100%",
        alignItems: 'center',
        justifyContent: 'end',
        padding: '20px 8px',
        fontSize: '16px',
        cursor: 'pointer',
      }}
      onMouseEnter={() => setIsOpen(true)} // Show dropdown on hover
      onMouseLeave={() => setIsOpen(false)} // Hide dropdown when mouse leaves
    >
      {/* Selected language display */}
      <div>
        <img
          src={selectedLanguage.image}
          alt={selectedLanguage.name}
          style={{ width: '15px', height: '15px', marginRight: '10px' }}
        />
        <span>{selectedLanguage.name.substring(0, 3)}</span>
      </div>

      {/* Custom dropdown menu */}
      {isOpen && (
        <ul
          style={{
            position: 'absolute',
            top: '100%',
            left: '0',
            right: '0',
            margin: '0',
            padding: '0',
            listStyle: 'none',
            backgroundColor: 'white',
            color: '#000', // Set dropdown text color to black
            maxHeight: '200px',
            overflowY: 'auto',
            zIndex: '10',
            borderRadius: '4px', // Optional: Adds border radius to the dropdown
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', // Optional: Adds a subtle shadow
          }}
        >
          {languages.map((language) => (
            <li
              key={language.code}
              onClick={() => handleLanguageSelect(language)} // Select a language from the list
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '8px',
                cursor: 'pointer',
                backgroundColor: selectedLanguage.code === language.code ? '#007bff' : 'transparent',
                color: selectedLanguage.code === language.code ? '#fff' : '#000',
                // borderRadius: '4px',
                transition: 'background-color 0.3s ease', // Smooth background transition
                fontSize: '14px'
              }}
              className='cus-lang-nav'
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#007bff';
                e.target.style.color = '#fff';
              }} // Hover effect for dropdown items
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = selectedLanguage.code === language.code ? '#007bff' : 'transparent';
                e.target.style.color = selectedLanguage.code === language.code ? '#fff' : '#000';
              }} // Remove hover effect
            >
              <img
                src={language.image}
                alt={language.name}
                style={{ width: '15px', height: '15px', marginRight: '13px' }}
              />
              <span>{language.name}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Languageoption;
